module.exports = __webpack_public_path__ + "img/sozialschnellgut_7_a.f91fed0f.jpg";